// extracted by mini-css-extract-plugin
export default {"productGallery":"iJ-z","inQuickShop":"jJ-z"};